import state from '@/taskpane/state/sidebar-state'
import AttachmentInfo from '../events/models/attachment-info'
import MailInfo from '@/taskpane/events/models/mail-info'
import EventInfo from '../events/models/event-info'
import AttachmentContents from '../events/models/attachment-contents'
import graph from '../graph/graph-wrapper'

function isApiAvailable() {
  return state.currentItem.apiInfo.isGraphApiAvailable
}

function setApiAsUnavailable() {
  state.currentItem.apiInfo.isGraphApiAvailable = false
}

async function officeApiMailItem_GetInfo(id: string): Promise<MailInfo> {
  return graph.getMailInfo(id)
}

async function officeApiMailItem_setMailCustomProperties(id: string, keyValuePairs: { [key: string]: string }) {
  return graph.setMailCustomProperties(id, keyValuePairs)
}

async function officeApiMailItem_getSentEmailsToProcess(lastProcessedDateTime: Date): Promise<any> {
  return graph.getSentEmailsToProcess(lastProcessedDateTime.toISOString())
}

async function officeApiEventItem_GetInfo(id: string): Promise<EventInfo> {
  return graph.getEventInfo(id)
}

async function officeApiMailItem_GetAttachment(id: string, attachment: AttachmentInfo): Promise<AttachmentContents> {
  return graph.getMailAttachment(id, attachment)
}

async function officeApiEventItem_GetAttachment(id: string, attachment: AttachmentInfo): Promise<AttachmentContents> {
  return graph.getEventAttachment(id, attachment)
}

const officeApiWrapper = {
  isAvailable: isApiAvailable,
  setAsUnavailable: setApiAsUnavailable,
  getMailInfo: officeApiMailItem_GetInfo,
  setMailCustomProperties: officeApiMailItem_setMailCustomProperties,
  getSentEmailsToProcess: officeApiMailItem_getSentEmailsToProcess,
  getEventInfo: officeApiEventItem_GetInfo,
  getMailAttachment: officeApiMailItem_GetAttachment,
  getEventAttachment: officeApiEventItem_GetAttachment,
}

export default officeApiWrapper
